export enum RouteStatusEnum {
  Suggestion = "Suggestion",
  Unassigned = "Unassigned",
  InMarket = "InMarket",
  Assigned = "Assigned",
  Started = "Started",
  Canceled = "Canceled",
  Completed = "Completed",
  Deleted = "Deleted"
}
